// extracted by mini-css-extract-plugin
export default {"tooltip-wrapper":"TooltipWrapper_tooltip-wrapper__a1BYx","tooltip-wrapper--visual-type-dark":"TooltipWrapper_tooltip-wrapper--visual-type-dark__NyuPJ"};